import { render, staticRenderFns } from "./TaskComments.vue?vue&type=template&id=b70e9fd4"
import script from "./TaskComments.vue?vue&type=script&lang=js"
export * from "./TaskComments.vue?vue&type=script&lang=js"
import style0 from "./TaskComments.vue?vue&type=style&index=0&id=b70e9fd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports